export const RELEASE_SALES_INVOICE_MUTATION = gql`
    mutation ReleaseSalesInvoice($id: Int!) {
        releaseSalesInvoice(id: $id) {
            id
            status
            sageInvoiceId
            sageInvoiceStatus
            sageInvoiceNumber
        }
    }
`;
